import React, { Suspense, lazy, useEffect, useState } from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { validateStoredSession } from "./config/directus";
import LandingPage from "./components/landingPage/LandingPage";

const Login = lazy(() => import("./components/auth/Login"));
const Dashboard = lazy(() => import("./components/dashboard/Dashboard"));
const Users = lazy(() => import("./views/common/Users"));
const Profile = lazy(() => import("./components/dashboard/Profile"));
const NotFound = lazy(() => import("./views/common/not_found/NotFound"));
const BusList = lazy(() => import("./views/admin/BusCard/BusList"));
const BusInfo = lazy(() => import("./views/admin/BusCard/BusInfo"));
const BookingDetails = lazy(() => import("./views/common/BookingDetails"));
const Report = lazy(() => import("./components/Report/Report"));
const Password = lazy(() => import("./components/dashboard/Passward"));
const BookNow = lazy(() => import("./views/common/BookNow"));

function defaultHomeForRole() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw) return "/dashboard";
    const u = JSON.parse(raw);
    return u.role === "admin" ? "/dashboard" : "/bookings";
  } catch {
    return "/dashboard";
  }
}

function App() {
  const [authChecked, setAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const ok = await validateStoredSession();
      if (!cancelled) {
        setIsAuthenticated(ok);
        setAuthChecked(true);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!authChecked) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "grid",
          placeItems: "center",
          color: "#0D1B2A",
        }}
      >
        Checking session…
      </div>
    );
  }

  const guard = (element) =>
    isAuthenticated ? element : <Navigate to="/login" replace />;

  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              minHeight: "100vh",
              display: "grid",
              placeItems: "center",
              color: "#0D1B2A",
            }}
          >
            Loading...
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to={defaultHomeForRole()} replace />
              ) : (
                <Login />
              )
            }
          />
          <Route
            path="/register"
            element={
              isAuthenticated ? (
                <Navigate to={defaultHomeForRole()} replace />
              ) : (
                <Login />
              )
            }
          />
          <Route path="/users" element={guard(<Users />)} />
          <Route path="/bus" element={guard(<BusList />)} />
          <Route path="/bookings" element={guard(<BookingDetails />)} />
          <Route path="/seatview" element={guard(<BusInfo withSideBar={true} />)} />
          <Route path="/dashboard" element={guard(<Dashboard />)} />
          <Route path="/settings/profile" element={guard(<Profile />)} />
          <Route path="/book-now" element={guard(<BookNow />)} />
          <Route path="/settings/password" element={guard(<Password />)} />
          <Route path="/reports" element={guard(<Report />)} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <ToastContainer />
    </Router>
  );
}

export default App;
